// extracted by mini-css-extract-plugin
export var bubble = "spiralgraph-module--bubble--zlsDa";
export var bubblePathSVG = "spiralgraph-module--bubblePathSVG--642Of";
export var community = "spiralgraph-module--community--D+4Bj";
export var left = "spiralgraph-module--left--epDai";
export var legend = "spiralgraph-module--legend--lw3Kh";
export var legendAoc = "spiralgraph-module--legendAoc--K0nHT";
export var legendComms = "spiralgraph-module--legendComms--JGxnv";
export var piggy = "spiralgraph-module--piggy--zMZMN";
export var right = "spiralgraph-module--right--PsPEd";
export var spiralGraph = "spiralgraph-module--spiralGraph--PAx1a";